/**
 * React Router configuration.
 *
 * Phase: 3 (public lookup), 4+ (admin routes wrapped in ProtectedRoute + AdminLayout)
 *
 * Layout:
 *   /                                       → public Lookup
 *   /admin/login                            → admin Login (unguarded)
 *   /admin                                  → ProtectedRoute → AdminLayout
 *     /admin/events                         → Events
 *     /admin/events/:eventId                → EventDetail
 *     /admin/events/:eventId/upload         → CertificateUpload
 *   *                                       → NotFound
 */

import { Anchor, Container, Stack, Text, Title } from "@mantine/core";
import { createBrowserRouter, Link, Navigate } from "react-router-dom";
import { AdminLayout } from "./components/AdminLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CertificateUpload } from "./pages/admin/CertificateUpload";
import { EventDetail } from "./pages/admin/EventDetail";
import { Events } from "./pages/admin/Events";
import { Login } from "./pages/admin/Login";
import { Lookup } from "./pages/public/Lookup";

function NotFound() {
  return (
    <Container size="xs" py="xl">
      <Stack gap="md" align="center">
        <Title order={1}>404</Title>
        <Text c="dimmed">Aradığınız sayfa bulunamadı.</Text>
        <Anchor component={Link} to="/">
          ← Ana sayfaya dön
        </Anchor>
      </Stack>
    </Container>
  );
}

export const router = createBrowserRouter([
  { path: "/", element: <Lookup /> },
  { path: "/admin/login", element: <Login /> },
  {
    path: "/admin",
    element: <ProtectedRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="events" replace /> },
          { path: "events", element: <Events /> },
          { path: "events/:eventId", element: <EventDetail /> },
          { path: "events/:eventId/upload", element: <CertificateUpload /> },
        ],
      },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
